import { Injectable } from '@angular/core';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { SearchableEntityDataService } from './searchable-entity-data.service';
import { SearchableEntityBackendService } from './searchable-entity-backend.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { PropertyChangeEvent } from '../../models/property-change-event';
import { SearchableEntityActionService } from './searchable-entity-action.service';

@Injectable()
export class SearchableEntityDataEditorService extends DataTableEditorService {

  protected backendService: SearchableEntityBackendService;
  protected dataService: SearchableEntityDataService;
  protected actionService: SearchableEntityActionService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public setDependentServices(dataService, backendService, actionService) {
    this.dataService = dataService;
    this.backendService = backendService;
    this.actionService = actionService;
  }

  /**
   * This method handles the changes to the property value
   * @param event - Property Change Event
   */
  public propertyValueChanged(event: PropertyChangeEvent): boolean {
    return true;
  }
  /**
   * This method is used to refresh the cells of the table
   * @param params - cell params
   */
  public refreshCells(params: any) {
    params.api.refreshCells({ force: true });
  }
  public getValuesBasedOnStorer(originalCoptions: any) {
    const storerKey = this.dataService.originalDataMap['storerKey'];
    let filteredCoptions;
    if (storerKey && storerKey.cVal) {
      filteredCoptions = originalCoptions.filter(element => 
        element.storerkey &&
        storerKey.cVal &&
        element.storerkey.toUpperCase() === storerKey.cVal.trim().toUpperCase()
      );
      if (filteredCoptions.length > 0) {
        filteredCoptions.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
   }
  }
    if (!filteredCoptions || filteredCoptions.length === 0) {
      filteredCoptions = originalCoptions.filter(element => !element.storerkey);
    }
    const filterOptions = filteredCoptions.length === 1 && filteredCoptions[0].key === '' &&
                          filteredCoptions[0].value.toLowerCase() === '- select -';
    if ( filterOptions ) {
      filteredCoptions = [];
    }
    return filteredCoptions;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/searchable-entity/searchable-entity-data-editor.service.ts